import { useConfigs } from '../lib/config-context';
import { HeaderFooterWrapper } from './HeaderFooterWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnFooterV2 = ({
  columnData
}) => {
  const {
    renderFooter
  } = useConfigs();
  if (typeof renderFooter !== 'function' || !!columnData.collapsed) {
    return null;
  }
  return /*#__PURE__*/_jsx(HeaderFooterWrapper, {
    borderStyleProps: {
      borderBlockStartColor: 'border-core-subtle',
      borderBlockStartStyle: 'solid',
      borderBlockStartWidth: '100'
    },
    children: renderFooter(columnData)
  });
};